import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getTotalsQueryOptions() {
  return queryOptions({
    queryKey: ["totals"],
    queryFn: getTotals,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
}

async function getTotals() {
  const response = await DefaultService.totalsGet();
  return response.collection;
}

type useTotalsOptions = {
  queryConfig?: QueryConfig<typeof getTotalsQueryOptions>;
};

export function useTotals({ queryConfig }: useTotalsOptions = {}) {
  return useQuery({
    ...getTotalsQueryOptions(),
    ...queryConfig,
  });
}